import { Component, DestroyRef, HostListener, inject, input, viewChild } from '@angular/core';
import { IconSpeaker } from '../../icons/i-speaker';
import { PronunciationService } from '../../services/pronunciation.service';
import { AudioEffectPlayer, AudioPlayer } from '../../utils/audio.utils';
import { RidAudioBubble } from '../rid-audio-bubble/rid-audio-bubble';

@Component({
  selector: 'rid-audio-button',
  imports: [IconSpeaker, RidAudioBubble],
  templateUrl: './rid-audio-button.html',
  host: {
    class: 'block place-items-center',
  },
})
export class RidAudioButton {
  private readonly $pronunciationService = inject(PronunciationService);
  private readonly destroyRef = inject(DestroyRef);

  src = input.required<string | { pronounce: string }>();
  size = input<'XSMALL' | 'SMALL' | 'MEDIUM' | 'LARGE'>('LARGE');

  audioBubble = viewChild.required<RidAudioBubble>('audioBubble');

  @HostListener('pointerenter')
  onHover() {
    AudioEffectPlayer.play('BUTTON_HOVER');
  }

  public async play() {
    this.audioBubble().play();
    const src = this.src();
    if (typeof src === 'string') {
      await AudioPlayer.play(src);
    } else {
      const txt = src.pronounce;
      await this.$pronunciationService.tryPronounce(txt, this.destroyRef);
    }
  }
}
